module.exports = __webpack_public_path__ + "img/IMG_6558_P_L_Wood.3d55369a.jpg";